import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {API_URL} from '@core/constants/global';

@Injectable({
  providedIn: 'root'
})
export class OpenviduService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getToken(params) {
      // todo
    // return this.httpClient.get(`https://9526-37-252-92-241.ngrok.io/users/session/get-token`, {params});
    return this.httpClient.get(`${API_URL}users/session/get-token`, {params});
    // return this.httpClient.post(`${API_URL}users/sessions`, {params});
  }
  openSession(params) {
      return this.httpClient.post(`${API_URL}users/sessions`, {
          categoryName: params.categoryName,
          category_id: params.category_id,
          description: params.description,
          name: params.name,
          tags: params.tags,
          thumbnail: params.thumbnail,
          privacy: params.privacy
      });
  }

  getSession() {
    return this.httpClient.post(`${API_URL}api/sessions`, {});
  }

  leaveSession(params){
    return this.httpClient.get(`${API_URL}users/session/leave`, {params});
  }
}
